module.exports = __webpack_public_path__ + "static/media/app_store.534724b3.png";